import {createClient} from "contentful";

export default createClient({
  space: "06xm5orkhl1h",
  accessToken: "n1TNYbU0YAtDVIAtwd5OR6ZqnSJjFeYmw-Q0O1prGBc"
})